import type { ApiConfig } from '../types';

export const apiConfig: ApiConfig = {
  baseURL: import.meta.env.VITE_API_BASE_URL,
  timeout: 15000,
};

export default apiConfig;
